import React, { useState } from "react";
import { Card, Button } from "react-bootstrap";
import EditEducationModal from "../Common_profile_details_modals/EditEducationModal/EditEducationModal";

function EducationCard() {
  const [showEducationModal, setShowEducationModal] = useState(false);

  const openEducationModal = () => {
    setShowEducationModal(true);
  };

  const closeEducationModal = () => {
    setShowEducationModal(false);
  };

  return (
    <>
      <Card className="profile-card-pattern">
        <Card.Body className="profile-card-pattern__body">
          <div className="profile-card-pattern__header">
            <Card.Title className="profile-card-pattern__title">
              Education
            </Card.Title>

            <Button
              variant="link"
              className="profile-card-pattern__btn-add"
              aria-label="Add Education"
              onClick={openEducationModal}
            >
              <span className="summary-card__edit-icon">➕</span>
            </Button>
          </div>

          <div className="profile-pattern-block-list">

            {/* Education 1 */}
            <div className="profile-pattern-block__item">
              <div className="profile-pattern-block__item-header">
                <h3 className="profile-pattern-block__main-text">
                  Bachelor Of Technology (B.Tech/B.E)
                </h3>

                <Button
                  variant="link"
                  className="profile-card-pattern__btn-edit"
                  aria-label="Edit degree"
                  onClick={openEducationModal}
                >
                  <span className="summary-card__edit-icon">✏️</span>
                </Button>
              </div>

              <p className="profile-pattern-block__sub-text">
                Suryodaya College of Engineering & Technology
              </p>

              <p className="profile-pattern-block__meta-text">
                2022
              </p>
            </div>

            {/* Education 2 */}
            <div className="profile-pattern-block__item">
              <div className="profile-pattern-block__item-header">
                <h3 className="profile-pattern-block__main-text">
                  Diploma
                </h3>

                <Button
                  variant="link"
                  className="profile-card-pattern__btn-edit"
                  aria-label="Edit diploma"
                  onClick={openEducationModal}
                >
                  <span className="summary-card__edit-icon">✏️</span>
                </Button>
              </div>

              <p className="profile-pattern-block__sub-text">
                Nagpur Polytechnic
              </p>

              <p className="profile-pattern-block__meta-text">
                2018
              </p>
            </div>

          </div>
        </Card.Body>
      </Card>

      {/* Education Modal */}
      <EditEducationModal
        show={showEducationModal}
        handleClose={closeEducationModal}
      />
    </>
  );
}

export default EducationCard;